
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("882hS", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");

});
parcelRegister("85Mv7", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $30069a8958953d8b$export$427e20518819fabc);

var $iFRCn = parcelRequire("iFRCn");

var $76xc7 = parcelRequire("76xc7");
function $30069a8958953d8b$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on iOS**
		 *
		 * _On iOS_
		 *
		 * - the browser will set the transparent border color to be black
		 * - While dragging, the drag preview will shift under the center of the users pointer.
		 *   So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 *   to be under the middle of the users pointer.
		 *
		 * _What we do_
		 *
		 * - We don't add the transparent border (to avoid the black)
		 * - We put center the drag preview under the users pointer (to avoid the drag preview
		 *   quickly moving so it's under the center of the users pointer).
		 *
		 * _Testing notes_
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a black border
		 * - The `<body>` text or background color does not change the black border color
		 */ if ((0, $iFRCn.isSafariOnIOS)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("iFRCn", function(module, exports) {

$parcel$export(module.exports, "isSafariOnIOS", () => $3720fb1a551ae595$export$52fc40c68fea4952);

var $aYpzB = parcelRequire("aYpzB");

var $e880Z = parcelRequire("e880Z");
const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});

});

parcelRegister("76xc7", function(module, exports) {

$parcel$export(module.exports, "centerUnderPointer", () => $54acc06d1c628398$export$81d8e72a15eef435);
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};

});




//# sourceMappingURL=modal.0719a6b3.js.map
